import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { setShowLoginModal } from "../../redux/reducer/modalReducer";

const itemCls = (active) =>
  `relative flex flex-1 flex-col items-center justify-center gap-0.5 py-1.5 text-xs font-medium no-underline transition-colors ${
    active ? "text-brand-700" : "text-slate-500"
  }`;

// Các route 2 đoạn KHÔNG phải trang sản phẩm (mirror routes.js: "/:category/:url")
const NON_PRODUCT = /^\/(danh-muc|thuong-hieu|nuoc-san-xuat|tim-kiem|bai-viet|chuyen-muc|trang|tac-gia|dashboard)\//;
const isProductPage = (pathname) => /^\/[^/]+\/[^/]+\/?$/.test(pathname) && !NON_PRODUCT.test(pathname);

/** Thanh điều hướng cố định dưới đáy (chỉ mobile) — kiểu app thương mại điện tử. */
const BottomNav = ({ cartCount, onOpenMenu }) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.authReducer?.login);

  // Trang sản phẩm / giỏ hàng có thanh hành động riêng (mua / đặt hàng) ở vị trí này
  if (isProductPage(pathname) || pathname === "/gio-hang") return null;

  return (
    <nav
      aria-label="Điều hướng nhanh"
      className="fixed inset-x-0 bottom-0 z-[800] flex border-t border-slate-200 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden"
    >
      <Link to="/" className={itemCls(pathname === "/")} aria-current={pathname === "/" ? "page" : undefined}>
        <i className={`bi ${pathname === "/" ? "bi-house-door-fill" : "bi-house-door"} text-xl`} aria-hidden="true" />
        Trang chủ
      </Link>
      <button type="button" onClick={onOpenMenu} className={itemCls(pathname.startsWith("/danh-muc"))}>
        <i className="bi bi-grid text-xl" aria-hidden="true" />
        Danh mục
      </button>
      <a href="https://zalo.me/0967711633" target="_blank" rel="noreferrer" className={itemCls(false)}>
        <i className="bi bi-chat-dots text-xl" aria-hidden="true" />
        Tư vấn
      </a>
      <Link to="/gio-hang" className={itemCls(pathname === "/gio-hang")} aria-label={`Giỏ hàng, ${cartCount} sản phẩm`}>
        <span className="relative">
          <i className={`bi ${pathname === "/gio-hang" ? "bi-bag-fill" : "bi-bag"} text-xl`} aria-hidden="true" />
          {cartCount > 0 && (
            <span className="absolute -right-2.5 -top-1 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-sale-600 px-1 text-[10px] font-bold leading-none text-white">
              {cartCount > 99 ? "99+" : cartCount}
            </span>
          )}
        </span>
        Giỏ hàng
      </Link>
      {currentUser ? (
        <Link to="/account" className={itemCls(pathname === "/account" || pathname === "/orders")}>
          <i className="bi bi-person text-xl" aria-hidden="true" />
          Tài khoản
        </Link>
      ) : (
        <button type="button" onClick={() => dispatch(setShowLoginModal(true))} className={itemCls(false)}>
          <i className="bi bi-person text-xl" aria-hidden="true" />
          Đăng nhập
        </button>
      )}
    </nav>
  );
};

export default BottomNav;
